/**
 * Chailease.SystemManagement.API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ActiveSubstituteSettingListViewModel } from '../model/activeSubstituteSettingListViewModel';
import { ApplyNewTicket } from '../model/applyNewTicket';
import { BPMUpdateStatusViewModel } from '../model/bPMUpdateStatusViewModel';
import { CancelationSubstituteSettingEditModel } from '../model/cancelationSubstituteSettingEditModel';
import { CommentViewModel } from '../model/commentViewModel';
import { PrincipalSubstitutionViewModel } from '../model/principalSubstitutionViewModel';
import { SubstituteApplyPagerViewModel } from '../model/substituteApplyPagerViewModel';
import { SubstituteApplySearchViewModel } from '../model/substituteApplySearchViewModel';
import { SubstituteApplyTodoViewModel } from '../model/substituteApplyTodoViewModel';
import { SubstituteApplyViewModel } from '../model/substituteApplyViewModel';
import { SubstituteCaseSearchViewModel } from '../model/substituteCaseSearchViewModel';
import { SubstituteRegulationRecordViewModel } from '../model/substituteRegulationRecordViewModel';
import { SubstituteRegulationSettingEditModel } from '../model/substituteRegulationSettingEditModel';
import { SubstituteRegulationSettingTodoViewModel } from '../model/substituteRegulationSettingTodoViewModel';
import { SubstitutionCaseDataViewModel } from '../model/substitutionCaseDataViewModel';
import { TaskInfo } from '../model/taskInfo';
import { TodoSearchViewModel } from '../model/todoSearchViewModel';
import { UsableUserProfileViewModel } from '../model/usableUserProfileViewModel';
import { UserJobTitleInfoViewModel } from '../model/userJobTitleInfoViewModel';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class SubstituteService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * [Public] 取得 流程Action清單
     *
     * @param processId
     * @param taskId
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public substituteActionsProcessIdTaskIdPost(processId: string, taskId: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<string>>;
    public substituteActionsProcessIdTaskIdPost(processId: string, taskId: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<string>>>;
    public substituteActionsProcessIdTaskIdPost(processId: string, taskId: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<string>>>;
    public substituteActionsProcessIdTaskIdPost(processId: string, taskId: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (processId === null || processId === undefined) {
            throw new Error('Required parameter processId was null or undefined when calling substituteActionsProcessIdTaskIdPost.');
        }

        if (taskId === null || taskId === undefined) {
            throw new Error('Required parameter taskId was null or undefined when calling substituteActionsProcessIdTaskIdPost.');
        }





        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<string>>('post',`${this.basePath}/Substitute/Actions/${encodeURIComponent(String(processId))}/${encodeURIComponent(String(taskId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Private] 取得 取消代理人設定清單
     *
     * @param principalSubstitute
     * @param companyId
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public substituteActiveSubStituteSettingPrincipalSubstituteGet(principalSubstitute: string, companyId?: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ActiveSubstituteSettingListViewModel>>;
    public substituteActiveSubStituteSettingPrincipalSubstituteGet(principalSubstitute: string, companyId?: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ActiveSubstituteSettingListViewModel>>>;
    public substituteActiveSubStituteSettingPrincipalSubstituteGet(principalSubstitute: string, companyId?: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ActiveSubstituteSettingListViewModel>>>;
    public substituteActiveSubStituteSettingPrincipalSubstituteGet(principalSubstitute: string, companyId?: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (principalSubstitute === null || principalSubstitute === undefined) {
            throw new Error('Required parameter principalSubstitute was null or undefined when calling substituteActiveSubStituteSettingPrincipalSubstituteGet.');
        }






        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (companyId !== undefined && companyId !== null) {
            queryParameters = queryParameters.set('companyId', <any>companyId);
        }

        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ActiveSubstituteSettingListViewModel>>('get',`${this.basePath}/Substitute/ActiveSubStituteSetting/${encodeURIComponent(String(principalSubstitute))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Private] 取得被代理人最近一次申請紀錄
     *
     * @param companyId
     * @param principalSubstitute
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public substituteApplicationCompanyCompanyIdPrincipalSubstitutePrincipalSubstituteLatestGet(companyId: number, principalSubstitute: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public substituteApplicationCompanyCompanyIdPrincipalSubstitutePrincipalSubstituteLatestGet(companyId: number, principalSubstitute: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public substituteApplicationCompanyCompanyIdPrincipalSubstitutePrincipalSubstituteLatestGet(companyId: number, principalSubstitute: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public substituteApplicationCompanyCompanyIdPrincipalSubstitutePrincipalSubstituteLatestGet(companyId: number, principalSubstitute: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (companyId === null || companyId === undefined) {
            throw new Error('Required parameter companyId was null or undefined when calling substituteApplicationCompanyCompanyIdPrincipalSubstitutePrincipalSubstituteLatestGet.');
        }

        if (principalSubstitute === null || principalSubstitute === undefined) {
            throw new Error('Required parameter principalSubstitute was null or undefined when calling substituteApplicationCompanyCompanyIdPrincipalSubstitutePrincipalSubstituteLatestGet.');
        }





        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<number>('get',`${this.basePath}/Substitute/Application/Company/${encodeURIComponent(String(companyId))}/PrincipalSubstitute/${encodeURIComponent(String(principalSubstitute))}/Latest`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Private] 查詢 指定單號 之 代理人設定
     *
     * @param companyId
     * @param substituteApplyId
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public substituteApplicationCompanyCompanyIdSubstituteApplyIdGet(companyId: number, substituteApplyId: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<SubstituteApplyViewModel>;
    public substituteApplicationCompanyCompanyIdSubstituteApplyIdGet(companyId: number, substituteApplyId: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SubstituteApplyViewModel>>;
    public substituteApplicationCompanyCompanyIdSubstituteApplyIdGet(companyId: number, substituteApplyId: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SubstituteApplyViewModel>>;
    public substituteApplicationCompanyCompanyIdSubstituteApplyIdGet(companyId: number, substituteApplyId: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (companyId === null || companyId === undefined) {
            throw new Error('Required parameter companyId was null or undefined when calling substituteApplicationCompanyCompanyIdSubstituteApplyIdGet.');
        }

        if (substituteApplyId === null || substituteApplyId === undefined) {
            throw new Error('Required parameter substituteApplyId was null or undefined when calling substituteApplicationCompanyCompanyIdSubstituteApplyIdGet.');
        }





        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<SubstituteApplyViewModel>('get',`${this.basePath}/Substitute/Application/Company/${encodeURIComponent(String(companyId))}/${encodeURIComponent(String(substituteApplyId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Private] 建立/修改 代理人設定
     *
     * @param body
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public substituteApplicationPost(body?: SubstituteApplyViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<TaskInfo>;
    public substituteApplicationPost(body?: SubstituteApplyViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TaskInfo>>;
    public substituteApplicationPost(body?: SubstituteApplyViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TaskInfo>>;
    public substituteApplicationPost(body?: SubstituteApplyViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<TaskInfo>('post',`${this.basePath}/Substitute/Application`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Private] 查詢 被代理人 之 有效規章代理人設定
     *
     * @param companyId
     * @param principalSubstitute
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public substituteApplicationRecordsCompanyCompanyIdPrincipalSubstitutePrincipalSubstituteGet(companyId: number, principalSubstitute: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<SubstituteRegulationRecordViewModel>>;
    public substituteApplicationRecordsCompanyCompanyIdPrincipalSubstitutePrincipalSubstituteGet(companyId: number, principalSubstitute: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<SubstituteRegulationRecordViewModel>>>;
    public substituteApplicationRecordsCompanyCompanyIdPrincipalSubstitutePrincipalSubstituteGet(companyId: number, principalSubstitute: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<SubstituteRegulationRecordViewModel>>>;
    public substituteApplicationRecordsCompanyCompanyIdPrincipalSubstitutePrincipalSubstituteGet(companyId: number, principalSubstitute: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (companyId === null || companyId === undefined) {
            throw new Error('Required parameter companyId was null or undefined when calling substituteApplicationRecordsCompanyCompanyIdPrincipalSubstitutePrincipalSubstituteGet.');
        }

        if (principalSubstitute === null || principalSubstitute === undefined) {
            throw new Error('Required parameter principalSubstitute was null or undefined when calling substituteApplicationRecordsCompanyCompanyIdPrincipalSubstitutePrincipalSubstituteGet.');
        }





        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<SubstituteRegulationRecordViewModel>>('get',`${this.basePath}/Substitute/Application/Records/Company/${encodeURIComponent(String(companyId))}/PrincipalSubstitute/${encodeURIComponent(String(principalSubstitute))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Private] 查詢 代理人設定紀錄
     *
     * @param body
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public substituteApplicationRecordsSearchPost(body?: SubstituteApplySearchViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<SubstituteApplyPagerViewModel>;
    public substituteApplicationRecordsSearchPost(body?: SubstituteApplySearchViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SubstituteApplyPagerViewModel>>;
    public substituteApplicationRecordsSearchPost(body?: SubstituteApplySearchViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SubstituteApplyPagerViewModel>>;
    public substituteApplicationRecordsSearchPost(body?: SubstituteApplySearchViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<SubstituteApplyPagerViewModel>('post',`${this.basePath}/Substitute/Application/Records/Search`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Public] 更新代理人狀態
     *
     * @param substituteApplyId
     * @param body
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public substituteApplicationStatusSubstituteApplyIdPost(substituteApplyId: number, body?: BPMUpdateStatusViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<BPMUpdateStatusViewModel>;
    public substituteApplicationStatusSubstituteApplyIdPost(substituteApplyId: number, body?: BPMUpdateStatusViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BPMUpdateStatusViewModel>>;
    public substituteApplicationStatusSubstituteApplyIdPost(substituteApplyId: number, body?: BPMUpdateStatusViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BPMUpdateStatusViewModel>>;
    public substituteApplicationStatusSubstituteApplyIdPost(substituteApplyId: number, body?: BPMUpdateStatusViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (substituteApplyId === null || substituteApplyId === undefined) {
            throw new Error('Required parameter substituteApplyId was null or undefined when calling substituteApplicationStatusSubstituteApplyIdPost.');
        }






        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<BPMUpdateStatusViewModel>('post',`${this.basePath}/Substitute/Application/Status/${encodeURIComponent(String(substituteApplyId))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Public] 取得 代理人設定 代辦列表
     *
     * @param body
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public substituteApplicationTodoSearchPost(body?: TodoSearchViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<SubstituteApplyTodoViewModel>;
    public substituteApplicationTodoSearchPost(body?: TodoSearchViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SubstituteApplyTodoViewModel>>;
    public substituteApplicationTodoSearchPost(body?: TodoSearchViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SubstituteApplyTodoViewModel>>;
    public substituteApplicationTodoSearchPost(body?: TodoSearchViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<SubstituteApplyTodoViewModel>('post',`${this.basePath}/Substitute/Application/Todo/Search`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Private] 建立/修改 取消代理人設定
     *
     * @param body
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public substituteCancelationSubStituteSettingSettingPost(body?: CancelationSubstituteSettingEditModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public substituteCancelationSubStituteSettingSettingPost(body?: CancelationSubstituteSettingEditModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public substituteCancelationSubStituteSettingSettingPost(body?: CancelationSubstituteSettingEditModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public substituteCancelationSubStituteSettingSettingPost(body?: CancelationSubstituteSettingEditModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/Substitute/CancelationSubStituteSetting/Setting`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Private] 查詢 代理人案件列表
     *
     * @param body
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public substituteCaseSearchPost(body?: SubstituteCaseSearchViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<SubstitutionCaseDataViewModel>;
    public substituteCaseSearchPost(body?: SubstituteCaseSearchViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SubstitutionCaseDataViewModel>>;
    public substituteCaseSearchPost(body?: SubstituteCaseSearchViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SubstitutionCaseDataViewModel>>;
    public substituteCaseSearchPost(body?: SubstituteCaseSearchViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<SubstitutionCaseDataViewModel>('post',`${this.basePath}/Substitute/Case/Search`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Public] 取得 申請流程備註清單
     *
     * @param processId
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public substituteCommentsProcessIdGet(processId: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<CommentViewModel>>;
    public substituteCommentsProcessIdGet(processId: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<CommentViewModel>>>;
    public substituteCommentsProcessIdGet(processId: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<CommentViewModel>>>;
    public substituteCommentsProcessIdGet(processId: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (processId === null || processId === undefined) {
            throw new Error('Required parameter processId was null or undefined when calling substituteCommentsProcessIdGet.');
        }





        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<CommentViewModel>>('get',`${this.basePath}/Substitute/Comments/${encodeURIComponent(String(processId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Private] 查詢指定 使用者 之 代理資訊
     *
     * @param userNo
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public substitutePrincipalSubstituteUserNoGet(userNo: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<PrincipalSubstitutionViewModel>;
    public substitutePrincipalSubstituteUserNoGet(userNo: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PrincipalSubstitutionViewModel>>;
    public substitutePrincipalSubstituteUserNoGet(userNo: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PrincipalSubstitutionViewModel>>;
    public substitutePrincipalSubstituteUserNoGet(userNo: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (userNo === null || userNo === undefined) {
            throw new Error('Required parameter userNo was null or undefined when calling substitutePrincipalSubstituteUserNoGet.');
        }





        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<PrincipalSubstitutionViewModel>('get',`${this.basePath}/Substitute/PrincipalSubstitute/${encodeURIComponent(String(userNo))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Private] 查詢 部門代號 是否可進行規章代理人申請
     *
     * @param deptId 部門代號
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public substituteRegulationSettingDeptDeptIdApplyNewTicketGet(deptId: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<ApplyNewTicket>;
    public substituteRegulationSettingDeptDeptIdApplyNewTicketGet(deptId: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ApplyNewTicket>>;
    public substituteRegulationSettingDeptDeptIdApplyNewTicketGet(deptId: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ApplyNewTicket>>;
    public substituteRegulationSettingDeptDeptIdApplyNewTicketGet(deptId: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (deptId === null || deptId === undefined) {
            throw new Error('Required parameter deptId was null or undefined when calling substituteRegulationSettingDeptDeptIdApplyNewTicketGet.');
        }





        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ApplyNewTicket>('get',`${this.basePath}/Substitute/Regulation/Setting/Dept/${encodeURIComponent(String(deptId))}/ApplyNewTicket`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Private] 查詢 所有 規章代理人設定
     *
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public substituteRegulationSettingGet(xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<SubstituteRegulationSettingEditModel>>;
    public substituteRegulationSettingGet(xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<SubstituteRegulationSettingEditModel>>>;
    public substituteRegulationSettingGet(xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<SubstituteRegulationSettingEditModel>>>;
    public substituteRegulationSettingGet(xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<SubstituteRegulationSettingEditModel>>('get',`${this.basePath}/Substitute/Regulation/Setting`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Private] 建立/修改 規章代理人設定
     *
     * @param body
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public substituteRegulationSettingPost(body?: SubstituteRegulationSettingEditModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<TaskInfo>;
    public substituteRegulationSettingPost(body?: SubstituteRegulationSettingEditModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TaskInfo>>;
    public substituteRegulationSettingPost(body?: SubstituteRegulationSettingEditModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TaskInfo>>;
    public substituteRegulationSettingPost(body?: SubstituteRegulationSettingEditModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<TaskInfo>('post',`${this.basePath}/Substitute/Regulation/Setting`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Private] 查詢 指定單號 之 規章代理人設定
     *
     * @param substituteRegulationSettingId
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public substituteRegulationSettingSubstituteRegulationSettingIdGet(substituteRegulationSettingId: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<SubstituteRegulationSettingEditModel>;
    public substituteRegulationSettingSubstituteRegulationSettingIdGet(substituteRegulationSettingId: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SubstituteRegulationSettingEditModel>>;
    public substituteRegulationSettingSubstituteRegulationSettingIdGet(substituteRegulationSettingId: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SubstituteRegulationSettingEditModel>>;
    public substituteRegulationSettingSubstituteRegulationSettingIdGet(substituteRegulationSettingId: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (substituteRegulationSettingId === null || substituteRegulationSettingId === undefined) {
            throw new Error('Required parameter substituteRegulationSettingId was null or undefined when calling substituteRegulationSettingSubstituteRegulationSettingIdGet.');
        }





        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<SubstituteRegulationSettingEditModel>('get',`${this.basePath}/Substitute/Regulation/Setting/${encodeURIComponent(String(substituteRegulationSettingId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Private] 取得 規章代理人設定 之 可使用的被代理人職稱
     *
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public substituteRegulationSettingUsablePrincipalSubstituteUserJobTitleGet(xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<UserJobTitleInfoViewModel>>;
    public substituteRegulationSettingUsablePrincipalSubstituteUserJobTitleGet(xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<UserJobTitleInfoViewModel>>>;
    public substituteRegulationSettingUsablePrincipalSubstituteUserJobTitleGet(xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<UserJobTitleInfoViewModel>>>;
    public substituteRegulationSettingUsablePrincipalSubstituteUserJobTitleGet(xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<UserJobTitleInfoViewModel>>('get',`${this.basePath}/Substitute/Regulation/Setting/Usable/PrincipalSubstituteUserJobTitle`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Public] 更新規章代理人狀態
     *
     * @param substituteRegulationSettingId
     * @param body
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public substituteRegulationStatusSubstituteRegulationSettingIdPost(substituteRegulationSettingId: number, body?: BPMUpdateStatusViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<BPMUpdateStatusViewModel>;
    public substituteRegulationStatusSubstituteRegulationSettingIdPost(substituteRegulationSettingId: number, body?: BPMUpdateStatusViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BPMUpdateStatusViewModel>>;
    public substituteRegulationStatusSubstituteRegulationSettingIdPost(substituteRegulationSettingId: number, body?: BPMUpdateStatusViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BPMUpdateStatusViewModel>>;
    public substituteRegulationStatusSubstituteRegulationSettingIdPost(substituteRegulationSettingId: number, body?: BPMUpdateStatusViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (substituteRegulationSettingId === null || substituteRegulationSettingId === undefined) {
            throw new Error('Required parameter substituteRegulationSettingId was null or undefined when calling substituteRegulationStatusSubstituteRegulationSettingIdPost.');
        }






        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<BPMUpdateStatusViewModel>('post',`${this.basePath}/Substitute/Regulation/Status/${encodeURIComponent(String(substituteRegulationSettingId))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Private] 取得 規章代理人設定 代辦列表
     *
     * @param body
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public substituteRegulationTodoSearchPost(body?: TodoSearchViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<SubstituteRegulationSettingTodoViewModel>;
    public substituteRegulationTodoSearchPost(body?: TodoSearchViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SubstituteRegulationSettingTodoViewModel>>;
    public substituteRegulationTodoSearchPost(body?: TodoSearchViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SubstituteRegulationSettingTodoViewModel>>;
    public substituteRegulationTodoSearchPost(body?: TodoSearchViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<SubstituteRegulationSettingTodoViewModel>('post',`${this.basePath}/Substitute/Regulation/todo/search`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Private] 取得 代理人 之 可使用的人員
     *
     * @param companyId 公司代號(選填)
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public substituteUsableUserGet(companyId?: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<UsableUserProfileViewModel>>;
    public substituteUsableUserGet(companyId?: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<UsableUserProfileViewModel>>>;
    public substituteUsableUserGet(companyId?: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<UsableUserProfileViewModel>>>;
    public substituteUsableUserGet(companyId?: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (companyId !== undefined && companyId !== null) {
            queryParameters = queryParameters.set('companyId', <any>companyId);
        }

        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<UsableUserProfileViewModel>>('get',`${this.basePath}/Substitute/UsableUser`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
